/** Time interval in milliseconds between PDF readiness checks. */
export const ORDER_PDF_POLL_INTERVAL_MILLISECONDS: number = 2000;

/** Safety timeout for polling PDF generation status in milliseconds (60 seconds). */
export const ORDER_PDF_TIMEOUT_MILLISECONDS: number = 60000;

/**
 * Result returned by createOrderPdfDownloadUrl mutation.
 */
export interface OrderPdfDownloadUrlResult {
  pdfStatus?: string | null;
  errorCode?: string | null;
  lastPdfError?: string | null;
  userMessage?: string | null;
  url?: string | null;
  expiresAt?: string | null;
}

/**
 * Result returned by retryGenerateOrderPdf mutation.
 */
export interface RetryGenerateOrderPdfResult {
  orderId: string;
  pdfStatus?: string | null;
  pdfGeneratedAt?: string | null;
}
